import AxiosFactory from "../shared/axiosFactory";
import sharedConfig from "../shared/config";

const appApi = new AxiosFactory({
    baseURL: sharedConfig.fhcBackendURL,
    withCredentials: true,
    paramsSerializer: {
        indexes: null,
    },
}).create();

export default appApi;
